<template>
  <div class="hidden w-full bg-white text-base leading-5 text-black lg:block">
    <div
      class="container flex flex-row items-center justify-center gap-24 px-4 py-2"
    >
      <div
        v-for="(benefit, index) in benefits"
        :key="index"
        class="flex items-center gap-2"
      >
        <IconUiCheckmark class="inline-block size-3 flex-none text-black" />
        <span class="whitespace-nowrap text-sm">
          {{ $t(benefit) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const benefits = [
  'benefits.exclusive_collections',
  'benefits.perfect_fit',
  'benefits.premium_quality',
]
</script>
